export enum MedicalCertificateType {
    agonistico = 1,
    nonAgonistico = 2
}

const MEDICAL_CERTIFICATE_TYPE_TRANSLATION_KEYS: Record<MedicalCertificateType, string> = {
    [MedicalCertificateType.agonistico]: 'agonistico',
    [MedicalCertificateType.nonAgonistico]: 'no_agonistico'
};

export function getMedicalCertificateTypeText(medicalType: MedicalCertificateType | null): string {
    return medicalType ? MEDICAL_CERTIFICATE_TYPE_TRANSLATION_KEYS[medicalType] ?? '' : '';
}

const MEDICAL_CERTIFICATE_TYPE_TITLE_TRANSLATION_KEYS: Record<MedicalCertificateType, string> = {
    [MedicalCertificateType.agonistico]: 'agonistic_certificate',
    [MedicalCertificateType.nonAgonistico]: 'non_agonistic_certificate'
};

export function getMedicalCertificateTypeTitleText(medicalType: MedicalCertificateType | null): string {
    return medicalType ? MEDICAL_CERTIFICATE_TYPE_TITLE_TRANSLATION_KEYS[medicalType] ?? '' : '';
}
